// Auto-generated by scripts/export_digests.py — do not edit by hand.
//
// Same data as digests.json, re-exported as a plain ESM array instead of a
// JSON import. See the docstring at the top of scripts/export_digests.py for
// why: a JSON import needs an import attribute this repo's pinned vitest
// cannot parse, and web/scripts/prerender-seo.mjs and
// web/scripts/generate-sitemap.mjs need to load this in plain Node the same
// way they already load src/config/rapportvakt.js.
//
// Regenerate both files together with:
//   uv run python scripts/export_digests.py

export const RAPPORTVAKT_DIGESTS = [];
